import { useDelete } from '@refinedev/core';

export function useDeleteAgenda() {
  const { mutateAsync, error, isLoading, reset } = useDelete();

  const deleteMeetingAgenda = async (reportId: string) => {
    return mutateAsync({
      resource: `meeting-agendas`,
      id: reportId,
    });
  };

  return {
    deleteMeetingAgenda,
    error,
    isLoading,
    reset,
  };
}
